/* aw-guided-flow.js (variant C "Guided Flow")
 * Step engine + plan card. Economics and cart mechanics IDENTICAL to variant
 * B's aw-order-widget.js. New: the 4-step flow, region derived from the gate
 * ZIP, sessionStorage resume, and the "AW Theme Variant: C" cart attribute
 * (the Round 2 order-attribution marker; only C carries it).
 */
const dataEl = document.getElementById('aw-gf-data');
const rootEl = document.getElementById('AwGuidedFlow');
if (dataEl && rootEl) init(JSON.parse(dataEl.textContent));

/* One money format ("$104" / "$23.50"). Mirrors aw-money.liquid and usd() in
 * aw-cart-sync.js; keep in sync. */
function usd(cents) {
  const n = cents / 100;
  const digits = n % 1 === 0 ? 0 : 2;
  return '$' + n.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: 2 });
}

/* Composition -> first-order code. IDENTICAL to aw-order-widget.js and
 * aw-cart-sync.js; keep the three in sync. */
/* The only discount codes this theme owns. Anything else attached to the cart
 * belongs to the customer (a typed promo) or a referral/ambassador link
 * (LeadDyno / UpPromote); the cart API's discount field REPLACES the whole code
 * set, so a blind write strips it and kills that order's attribution and the
 * partner's commission. Fix 2026-07-20. */
const THEME_CODES = ['starter22', 'home77', 'family33'];

function offerCode(waterQty, hasDispenser) {
  const eligible = waterQty + (hasDispenser ? 1 : 0);
  if (waterQty < 1) return null;
  if (waterQty <= 3) return eligible >= 3 ? 'starter22' : null;
  if (waterQty <= 5) return hasDispenser && eligible >= 5 ? 'home77' : null;
  return eligible >= 7 ? 'family33' : null;
}

function clearDiscountCookie() {
  const expire = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  document.cookie = expire;
  document.cookie = expire + '; domain=.' + location.hostname.replace(/^www\./, '');
}

/* ZIP prefix -> region variant key: 005 + 070-089 + 100-149 -> NY/NJ,
 * 970-979 + 986 (Vancouver WA rides Portland routes) -> OR, else CA/FL/TX
 * (B's select default). String input keeps leading-zero ZIPs safe.
 * SURCHARGE RE-ENABLE requires auditing this map first - see theme-c/README.md. */
function zipRegionKey(zip) {
  const p = Number(String(zip).slice(0, 3));
  if (p === 5 || (p >= 70 && p <= 89) || (p >= 100 && p <= 149)) return 'NY/NJ';
  if ((p >= 970 && p <= 979) || p === 986) return 'OR';
  return 'CA/FL/TX';
}

function init(D) {
  // Full B-parity ladder (2026-07-20): trial sizes 1-3 (first delivery only)
  // + core 4-12 + self-serve bulk 16-32, matching B's aw-order-widget.liquid
  // quantity groups exactly. Pricing needs NO change: perJugCents already
  // bills the published curve, caps >12 at the 12-jug price, and bills
  // trials at the base jug price; offerCode and the 1:1 deposit match are
  // quantity-driven. Renewals for bulk bill qty x the 12-jug price, same as
  // B's aw-cart-sync curvePer().
  const QSTEPS = [1, 2, 3, 4, 6, 8, 10, 12, 16, 20, 24, 28, 32];
  const jugsWord = (n) => n + ' glass jug' + (n === 1 ? '' : 's');
  const HOUSEHOLD_QTY = { '1-2': 4, '3-4': 6, '5plus': 8, trial: 2 };

  const state = {
    step: 1,
    household: null,
    picked: false, // a plan was chosen (step 2 answer or tier table)
    qty: 4,
    weeks: 4,
    planId: null,
    dispenser: true,
    shelf: false,
    eligibility: readEligibility(),
  };

  const $ = (sel) => rootEl.querySelector(sel);
  const $$ = (sel) => Array.from(rootEl.querySelectorAll(sel));
  const out = (name) => $('[data-out="' + name + '"]');
  const row = (name) => $('[data-row="' + name + '"]');

  const panels = $$('.aw-gf__step');
  const dots = $$('[data-gf-dot]');
  const announceEl = $('#aw-gf-announce');
  const continueBtn = $('#aw-gf-continue');
  const freqMore = $('#aw-gf-freq-more');
  const shelfBox = $('#aw-gf-shelf');
  const dispRow = row('dispenser');
  const dispBtn = $('#aw-gf-dispenser-toggle');
  const addBtn = $('#aw-gf-add');
  // In-flight guard, mirroring the control arm. render() runs on every control
  // change (stepper, frequency chip, dispenser toggle, shelf, tier table, back)
  // and used to unconditionally re-enable the CTA and reset its label, so a
  // customer who adjusted anything mid-add got a live button back and could fire
  // a second add that merged with the first - doubled jugs, doubled deposits and
  // a doubled RECURRING subscription.
  let adding = false;
  const allEl = $('#aw-gf-all');
  const gateEl = document.getElementById('aw-zip-gate');
  // Persistent route-note banner, rendered by the section OUTSIDE the step
  // panels. The gate paints the Oregon "delivery starts Q4 2026" note into its
  // own result node inside step 1, which is hidden from step 2 on and never
  // seen by a visitor whose stored ZIP boots them past it. Brian, 2026-07-21.
  const noteEl = document.getElementById('aw-gf-eligibility-note');
  // Offer stand-down state (Brian, 2026-07-21). applyOffer refuses to write our
  // code when a referral/ambassador/typed code already owns the cart, but the
  // summary kept promising the discount anyway, so a referral customer was shown
  // a total up to $77 below what checkout charges. null = our offer is live, a
  // string = the foreign code that wins ('' when the cart does not name it).
  // Sticky for the session because the stand-down also removes aw_offer_code;
  // applyOffer clears it again if the cart's codes change.
  let foreignCode = null;

  function readEligibility() {
    try { return JSON.parse(localStorage.getItem('aw_delivery')) || null; } catch (_) { return null; }
  }

  const KEY = 'aw_gf_v1';
  function save() {
    const { step, household, picked, qty, weeks, planId, planOv, dispenser, shelf } = state;
    try { sessionStorage.setItem(KEY, JSON.stringify({ step, household, picked, qty, weeks, planId, planOv, dispenser, shelf })); } catch (_) {}
  }
  function restore() {
    let had = false;
    try {
      const s = JSON.parse(sessionStorage.getItem(KEY));
      if (s) { Object.assign(state, s); had = true; }
    } catch (_) {}
    if (QSTEPS.indexOf(state.qty) === -1) state.qty = 4;
    return had;
  }

  const canOrder = () => !!(state.eligibility && state.eligibility.state !== 'waitlist');

  function region() {
    const key = state.eligibility && state.eligibility.zip ? zipRegionKey(state.eligibility.zip) : 'CA/FL/TX';
    // Fall back to any region rather than crash if a variant title is renamed.
    return D.regions[key] || D.regions['CA/FL/TX'] || D.regions[Object.keys(D.regions)[0]];
  }

  function planForWeeks(weeks) {
    const re = new RegExp('every\\s+' + weeks + '\\s+week', 'i');
    const one = weeks === 1 ? D.plans.find((p) => /every\s+week/i.test(p.name)) : null;
    return D.plans.find((p) => re.test(p.name)) || one || null;
  }

  function routeWeeks() {
    const el = state.eligibility || readEligibility();
    const w = el && el.state === 'served' && el.cadence && Number(el.cadence.weeks);
    return w > 0 ? w : null;
  }

  function weeksFromPlanName(name) {
    const m = String(name || '').match(/every\s+(\d+)?\s*week/i);
    return m ? (m[1] ? Number(m[1]) : 1) : null;
  }

  // Region-cadence enforcement, ported from B2's aw-order-widget.js
  // (2026-07-19 parity fix): in cadence regions the frequency choices are
  // limited to multiples of the route cadence, so a subscription can never
  // bill faster than its route runs. Owns ALL chip visibility - a chip also
  // hides when no Appstle plan backs its cadence.
  function applyCadenceUI() {
    const rw = routeWeeks();
    $$('.aw-freq__btn').forEach((b) => {
      const noPlan = !planForWeeks(Number(b.dataset.weeks));
      b.hidden = noPlan || (!!rw && Number(b.dataset.weeks) % rw !== 0);
    });
    Array.from(freqMore.options).forEach((o) => {
      if (!o.value) return;
      const w = weeksFromPlanName(o.dataset.name);
      const bad = !!rw && (!w || w % rw !== 0);
      o.hidden = bad;
      o.disabled = bad;
    });
    if (rw && state.weeks % rw !== 0) {
      setWeeks(rw);
      freqMore.value = state.planId ? String(state.planId) : '';
    }
  }

  const onCurve = (reg) => String(reg.id) === String(D.curveVariantId);

  function perJugCents(reg, qty) {
    if (!onCurve(reg)) return reg.cents;
    if (D.curve[String(qty)]) return D.curve[String(qty)];
    if (qty > 12) return D.curve['12'];
    return reg.cents; // trial sizes bill the base jug price
  }

  const announce = (text) => { if (announceEl) announceEl.textContent = text; };

  function markDot(n) {
    dots.forEach((d) => {
      const i = Number(d.dataset.gfDot);
      d.classList.toggle('is-current', i === n);
      d.classList.toggle('is-done', i < n);
      if (i === n) d.setAttribute('aria-current', 'step');
      else d.removeAttribute('aria-current');
    });
  }

  function goTo(n, opts) {
    const same = state.step === n;
    state.step = n;
    save();
    panels.forEach((p) => { p.hidden = Number(p.dataset.gfStep) !== n; });
    markDot(n);
    render();
    if (!(opts && opts.boot) && !same) {
      const h = document.querySelector('#aw-gf-step' + n + ' .aw-gf__h');
      announce('Step ' + n + ' of 4: ' + (h ? h.textContent : ''));
      if (h) h.focus();
    }
  }

  function render() {
    const E = state.eligibility;
    const reg = region();
    const per = perJugCents(reg, state.qty);
    const water = per * state.qty;
    const deposits = D.depositCents * state.qty;
    const dispCents = state.dispenser ? D.dispenserCents : 0;
    const addons = dispCents + (state.shelf ? D.shelfCents : 0);
    const fee = E && E.state === 'surcharge' ? E.fee * 100 : 0;

    // Offer math identical to aw-order-widget.js; deposits and fee never discount.
    let discount = 0;
    let offerLabel = '';
    // All three codes are new-customers-only and one use per customer, so a
    // logged-in customer who has already ordered can never redeem one. Quoting
    // it anyway loses them up to $77 between the card and checkout. Guests stay
    // eligible here because Shopify only resolves identity at email entry, so
    // their wording states the condition instead of promising. Brian, 2026-07-21.
    const code = D.offersLive && D.customerEligible ? offerCode(state.qty, state.dispenser) : null;
    if (code === 'starter22') {
      discount = Math.round(0.22 * (water + dispCents));
      offerLabel = 'Starter offer: 22% off, deposits excluded';
    } else if (code === 'home77') {
      discount = D.dispenserCents;
      offerLabel = 'Home offer: free dispenser';
    } else if (code === 'family33') {
      discount = Math.round(0.33 * (water + addons));
      offerLabel = 'Family offer: 33% off, deposits excluded';
    }
    // applyOffer stood down for a code the customer brought with them, so ours
    // is never written: promising it here would under-quote the real total.
    if (foreignCode !== null) discount = 0;
    const total = water + deposits + addons + fee - discount;

    const cadence = state.weeks === 1 ? 'every week' : 'every ' + state.weeks + ' weeks';
    const trial = state.qty < 4;
    const qi = QSTEPS.indexOf(state.qty);

    out('plan-title').textContent = trial
      ? 'Your trial: ' + jugsWord(state.qty) + ' of spring water, delivered once'
      : 'Your plan: ' + jugsWord(state.qty) + ' of spring water, delivered ' + cadence;

    out('qty').textContent = String(state.qty);
    $('#aw-gf-minus').disabled = qi <= 0;
    $('#aw-gf-plus').disabled = qi >= QSTEPS.length - 1;
    out('qty-note').textContent = trial
      ? 'Trial size, first delivery only. Deliveries after that continue on the 4 jug plan.'
      : state.qty === 4 ? 'Our recurring minimum is 4 jugs.' : '';

    out('water-label').textContent = jugsWord(state.qty) + ' of spring water (' + usd(per) + ' per jug)';
    out('water-price').textContent = usd(water);
    out('deposit-price').textContent = usd(deposits);

    row('addons').hidden = addons === 0;
    if (addons > 0) {
      const names = [];
      if (state.dispenser) names.push('Dispenser');
      if (state.shelf) names.push('White Steel Shelf');
      out('addons-label').textContent = names.join(' + ');
      out('addons-price').textContent = usd(addons);
    }

    row('fee').hidden = fee === 0;
    if (fee > 0) out('fee-price').textContent = usd(fee) + ' per delivery';

    // Only say a code displaced ours when this composition actually had one to
    // displace: with no qualifying offer (4 jugs, dispenser off) the sentence
    // would be a false claim on every render for the rest of the page view.
    const standDown = foreignCode !== null && !!code;
    row('offer').hidden = discount === 0 && !standDown;
    if (discount > 0) {
      // Logged in with 0 orders: Shopify has already confirmed they qualify, so
      // the promise is safe. A guest cannot be checked client-side, so the
      // wording states the condition instead of guaranteeing it. Both arms use
      // these exact strings (Brian, 2026-07-21).
      out('offer-label').textContent = offerLabel + (D.customerKnown
        ? ' (new customer offer, applied automatically at checkout)'
        : ' (new customer offer, applied at checkout on your first order)');
      out('offer-amount').textContent = '-' + usd(discount);
    } else if (standDown) {
      out('offer-label').textContent = foreignCode
        ? 'Code ' + foreignCode + ' from your cart applies at checkout, in place of our new customer offer.'
        : 'The code already on your cart applies at checkout, in place of our new customer offer.';
      out('offer-amount').textContent = '';
    }

    out('total-price').textContent = usd(total);

    const trialNote = out('trial-note');
    if (trial) {
      const renew = (onCurve(reg) && D.curve['4'] ? D.curve['4'] : reg.cents) * 4;
      const topup = D.depositCents * (4 - state.qty);
      out('renew-price').textContent = usd(renew);
      out('renew-cadence').textContent = cadence + ' on the 4 jug plan';
      trialNote.hidden = false;
      trialNote.textContent = 'Trial size: your first delivery is ' + jugsWord(state.qty) + '. Deliveries after that continue on our 4 jug minimum at ' + usd(renew) + ' per delivery, plus a one time ' + usd(topup) + ' refundable deposit top up on your first full delivery.';
    } else {
      out('renew-price').textContent = usd(water);
      out('renew-cadence').textContent = cadence + ', the published price, no surprises';
      trialNote.hidden = true;
    }

    const on = state.dispenser;
    dispRow.classList.toggle('is-off', !on);
    dispBtn.textContent = on ? dispBtn.dataset.onLabel : dispBtn.dataset.offLabel;
    dispBtn.setAttribute('aria-label', on ? dispBtn.dataset.onAria : dispBtn.dataset.offAria);
    out('dispenser-note').textContent = on ? dispBtn.dataset.onNote : dispBtn.dataset.offNote;
    out('region-note').hidden = !!E;
    if (noteEl) {
      const routeNote = E && E.note && E.note.note ? E.note.note + (E.note.cta ? ' ' + E.note.cta : '') : '';
      // The gate only paints the note in its SERVED branch: a surcharge result
      // prints the fee sentence and drops the note entirely, so suppressing the
      // banner on step 1 for every state left a surcharge ZIP with a note
      // showing nowhere at all. Step 1 now hides this banner only when the gate
      // is the one showing the note. Unhide BEFORE writing: text written while
      // the element is hidden is not in the a11y tree, so it is never announced.
      noteEl.hidden = !routeNote || (state.step < 2 && E.state === 'served');
      // render() runs on every control change and this is an aria-live region,
      // so an unconditional write re-announced the note on every keystroke-level
      // change. Write only when the note actually changes.
      if (noteEl.textContent !== routeNote) noteEl.textContent = routeNote;
    }
    $$('.aw-gf__opt').forEach((b) => b.classList.toggle('is-active', b.dataset.gfHousehold === state.household));

    continueBtn.hidden = !canOrder();
    const waitlisted = E && E.state === 'waitlist';
    const needsZip = !E && !!gateEl;
    const regionOut = canOrder() && reg.available === false; // B disables the option; C disables the CTA
    addBtn.disabled = adding || regionOut;
    addBtn.classList.toggle('aw-btn--needs-zip', needsZip || !!waitlisted);
    addBtn.textContent = adding ? 'Adding...'
      : waitlisted ? 'Join the waitlist first'
      : needsZip ? 'Enter your ZIP to order'
      : regionOut ? 'Ordering is paused for your region'
      : 'Start my delivery';
  }

  function setWeeks(weeks, planIdOverride) {
    const rw = routeWeeks();
    if (rw && !planIdOverride && Number(weeks) % rw !== 0) weeks = rw;
    state.weeks = Number(weeks);
    const plan = planIdOverride ? { id: planIdOverride } : planForWeeks(state.weeks);
    state.planId = plan ? plan.id : null;
    state.planOv = !!planIdOverride;
    $$('.aw-freq__btn').forEach((b) => b.classList.toggle('is-active', Number(b.dataset.weeks) === state.weeks && !planIdOverride));
    save();
    render();
  }

  function setQty(q) {
    state.qty = Number(q);
    if (state.qty <= 3) state.household = 'trial';
    else if (state.household === 'trial') state.household = null;
    save();
    render();
  }

  // --- Wiring ---

  document.addEventListener('aw:eligibility', (e) => {
    state.eligibility = e.detail;
    applyCadenceUI();
    if (!e.detail && state.step > 1) { goTo(1); return; }
    render();
  });

  continueBtn.addEventListener('click', () => { goTo(state.picked ? 3 : 2); });

  $$('.aw-gf__opt').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.household = btn.dataset.gfHousehold;
      state.qty = HOUSEHOLD_QTY[state.household] || 4;
      // Brian, 2026-07-21: never re-force the dispenser here. It already
      // defaults on at boot, so this only ever undid a deliberate removal, and
      // it moved the auto-applied offer code underneath the customer.
      state.picked = true;
      $$('.aw-gf__opt').forEach((b) => b.classList.toggle('is-active', b === btn));
      setWeeks(4);
      goTo(3);
    });
  });

  $$('[data-gf-back]').forEach((btn) => {
    btn.addEventListener('click', () => goTo(Number(btn.dataset.gfBack)));
  });

  $('#aw-gf-minus').addEventListener('click', () => {
    const i = QSTEPS.indexOf(state.qty);
    if (i > 0) setQty(QSTEPS[i - 1]);
  });
  $('#aw-gf-plus').addEventListener('click', () => {
    const i = QSTEPS.indexOf(state.qty);
    if (i < QSTEPS.length - 1) setQty(QSTEPS[i + 1]);
  });

  $$('.aw-freq__btn').forEach((b) => b.addEventListener('click', () => { freqMore.value = ''; setWeeks(b.dataset.weeks); }));
  freqMore.addEventListener('change', () => {
    if (!freqMore.value) return;
    const name = freqMore.selectedOptions[0].dataset.name || '';
    const m = name.match(/every\s+(\d+)?\s*week/i);
    setWeeks(m && m[1] ? m[1] : 1, Number(freqMore.value));
  });
  // Chip visibility (no-plan chips + cadence multiples) lives in applyCadenceUI.

  dispBtn.addEventListener('click', () => { state.dispenser = !state.dispenser; save(); render(); });
  shelfBox.addEventListener('change', () => { state.shelf = shelfBox.checked; save(); render(); });

  const tipBtn = $('[data-tip]');
  const tip = document.getElementById('aw-gf-deposit-tip');
  tipBtn.addEventListener('click', () => {
    const open = tip.classList.toggle('is-open');
    tipBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Product-photo previews: thumbnail tap opens a native dialog (Esc/backdrop
  // close for free). Thumbs sit outside the shelf label so a tap never
  // toggles the checkbox.
  const photoDlg = document.getElementById('aw-gf-photo-dialog');
  if (photoDlg && photoDlg.showModal) {
    rootEl.addEventListener('click', (e) => {
      const b = e.target.closest('[data-gf-photo]');
      if (!b) return;
      const img = photoDlg.querySelector('[data-gf-photo-img]');
      img.src = b.dataset.full;
      img.alt = b.dataset.name;
      photoDlg.querySelector('[data-gf-photo-name]').textContent = b.dataset.name;
      photoDlg.showModal();
    });
    photoDlg.addEventListener('click', (e) => {
      if (e.target === photoDlg || e.target.closest('[data-gf-photo-close]')) photoDlg.close();
    });
  }

  allEl.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-gf-choose]');
    if (!btn) return;
    const q = Number(btn.dataset.gfChoose);
    // Quantity-only controls (the trial and bulk pickers) change ONLY the
    // quantity. Variant B's quantity buttons have no side effects, so picking a
    // size must be the same gesture in both arms - forcing the dispenser on and
    // resetting the cadence here would hand the treatment a different offer mix
    // for an identical customer action. The tier-table "Choose this" rows keep
    // their original meaning: pick this whole recommended plan.
    state.picked = true;
    if (btn.dataset.gfQtyOnly !== undefined) {
      setQty(q);
      allEl.open = false;
      goTo(3);
      return;
    }
    state.qty = q;
    state.household = q <= 3 ? 'trial' : null;
    // Brian, 2026-07-21: no dispenser re-force here either, see the step 2 handler.
    setWeeks(4);
    allEl.open = false;
    goTo(3);
  });

  /* Carries the Round 2 arm marker: one retry, still non-blocking. */
  async function writeAttrs(attrs) {
    for (let i = 0; i < 2; i++) {
      try {
        const r = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs }),
        });
        if (r.ok) return;
      } catch (_) {}
      await new Promise((res) => setTimeout(res, 600));
    }
  }

  // Add to cart: water + matched deposits + add-ons in one call, then
  // attributes (ZIP set + the Round 2 arm marker), then the offer code.
  addBtn.addEventListener('click', async () => {
    if (adding) return; // second click while the first add is in flight doubles the order
    const E = state.eligibility;
    if (!canOrder()) {
      goTo(1);
      const zipInput = document.getElementById('aw-zip-input');
      if (zipInput && !(E && E.state === 'waitlist')) zipInput.focus({ preventScroll: true });
      return;
    }
    if (region().available === false) return; // CTA is disabled; belt and braces
    const err = out('error');
    err.hidden = true;
    adding = true;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';
    try {
      if (!state.planId) { // broken restore or renamed plans: never post a one-time order
        const fallback = planForWeeks(4) || D.plans[0];
        if (fallback) state.planId = fallback.id;
      }
      // "Start my delivery" SETS the cart to the plan: zero any existing
      // plan lines first, so going back to adjust (4 -> 6) then re-adding
      // replaces the order instead of stacking a second one on top - and the
      // offer code below is applied against an unambiguous composition.
      // Other products in the cart are left alone.
      const planVariants = [D.depositVariantId, D.dispenserVariantId, D.shelfVariantId]
        .concat(Object.keys(D.regions).map((k) => D.regions[k].id)).map(String);
      let existing = null; // retried: a swallowed read here would stack instead of replace
      for (let i = 0; i < 3 && !existing; i++) {
        existing = await fetch('/cart.js').then((r) => (r.ok ? r.json() : null)).catch(() => null);
        if (!existing) await new Promise((res) => setTimeout(res, 1200));
      }
      if (!existing) throw new Error('cart unreadable'); // honest retry beats a silently doubled order
      for (const line of existing.items) {
        if (planVariants.indexOf(String(line.variant_id)) === -1) continue;
        // A swallowed zeroing failure followed by the add DOUBLES the order
        // (observed under Cloudflare 429 bursts, incl. 2026-07-19): retry
        // once, then abort to the honest retry error like the guard read.
        let zr = null;
        for (let i = 0; i < 2 && !(zr && zr.ok); i++) {
          if (i) await new Promise((res) => setTimeout(res, 900));
          zr = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 }),
          }).catch(() => null);
        }
        if (!zr || !zr.ok) throw new Error('cart zero failed');
      }
      const items = [
        { id: region().id, quantity: state.qty, selling_plan: state.planId },
        { id: D.depositVariantId, quantity: state.qty },
      ];
      if (state.dispenser) items.push({ id: D.dispenserVariantId, quantity: 1 });
      if (state.shelf) items.push({ id: D.shelfVariantId, quantity: 1 });

      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!r.ok) throw new Error('add failed ' + r.status);

      // Affiliate ref rides the same write as the ZIP set and the arm marker, so
      // an affiliate link is credited even when the customer never uses that
      // affiliate's coupon (aw-affiliate-ref.js). Attribute NAMES must match the
      // control arm exactly or the experiment readout is confounded.
      await writeAttrs(Object.assign(
        (typeof window.awAffiliateAttrs === 'function') ? window.awAffiliateAttrs() : {},
        {
          'Delivery ZIP': E.zip,
          'Delivery Eligibility': E.state,
          'Delivery Fee': E.fee == null ? '' : String(E.fee),
          'Delivery Cadence': E.cadence ? 'once every ' + E.cadence.weeks + ' weeks (' + E.cadence.label + ')' : '',
          'AW Theme Variant': 'C',
        }
      ));

      await applyOffer();

      markDot(4);
      announce('Step 4 of 4: Cart');
      openCart();
    } catch (e) {
      err.hidden = false;
      err.textContent = 'Something went wrong adding to your cart. Please try again.';
    } finally {
      adding = false;
      // render() owns the button's disabled state and label. Belt and braces: if
      // it ever throws, restore the CTA rather than stranding a dead button.
      try { render(); } catch (_) {
        addBtn.disabled = false;
        addBtn.textContent = 'Start my delivery';
      }
    }
  });

  /* Auto-apply the first-order discount. C fork of B's mechanism: the cart
   * API's discount field REPLACES the cart's whole code set. B's
   * /discount/{code} route only APPENDS - Shopify then keeps whichever
   * attached code saves the customer most, which is how home77 (-$77) beat
   * family33 (-$74.91) on a 6 jug cart (Brian's 2026-07-18 report; same
   * mechanism as Round 1 finding 6). aw-cart-sync (C fork) re-asserts on
   * cart edits via aw_offer_code. */
  async function applyOffer() {
    if (!D.offersLive) return;
    // Returning customer: none of the three codes can be redeemed, so attaching
    // one only produces a cart total checkout refuses to honour. Write nothing
    // (which also leaves any code the customer brought with them untouched) and
    // clear aw_offer_code, so aw-cart-sync cannot re-assert the code left armed
    // by their FIRST order the next time quantities change (Brian, 2026-07-21).
    // aw-cart-sync ships on the drawer with no liquid data blob, so it cannot
    // read customerEligible; the durable marker is how it learns to stand down.
    // The eligible path clears the marker again, so a logout or a different
    // customer in the same browser is not permanently suppressed.
    if (!D.customerEligible) {
      try { localStorage.removeItem('aw_offer_code'); localStorage.setItem('aw_offer_ineligible', '1'); } catch (_) {}
      return;
    }
    try { localStorage.removeItem('aw_offer_ineligible'); } catch (_) {}
    const code = offerCode(state.qty, state.dispenser);
    try {
      // Never overwrite a code we did not put there. A customer who arrived on an
      // ambassador/affiliate link (or typed their own promo) keeps it; we simply
      // do not auto-apply ours. Fail CLOSED on an unreadable cart: guessing wrong
      // under a 429 burst would re-clobber the referral code this guard protects.
      // Retried like the add flow's cart read (Brian, 2026-07-21): a single 429
      // used to return here BEFORE arming aw_offer_code, so no code was attached
      // and aw-cart-sync, which is gated on that key, could never heal it.
      let cur = null;
      for (let i = 0; i < 3 && !cur; i++) {
        cur = await fetch('/cart.js').then((r) => (r.ok ? r.json() : null)).catch(() => null);
        if (!cur) await new Promise((res) => setTimeout(res, 1200));
      }
      // We still fail closed on the write, but arm aw-cart-sync rather than
      // leave it disarmed: its next reconcile pass can re-assert the code behind
      // its own THEME_CODES guard, so a foreign code is still safe.
      if (!cur) {
        localStorage.setItem('aw_offer_code', code || 'none');
        return;
      }
      // Name the winning code when the cart gives it, so render() can say which
      // one is being used instead of promising a discount we never write.
      const foreign = (cur.discount_codes || []).find((d) => THEME_CODES.indexOf(String(d.code || '').toLowerCase()) === -1);
      if (foreign) {
        foreignCode = String(foreign.code || '');
        try { localStorage.removeItem('aw_offer_code'); } catch (_) {}
        return;
      }
      foreignCode = null; // the cart's codes are ours again: the offer is live
      localStorage.setItem('aw_offer_code', code || 'none');
      // code null writes discount:'' on purpose: that is the only path that
      // DETACHES a theme code the composition no longer qualifies for, so the
      // cart never carries a discount the summary stopped quoting. Safe because
      // the foreign-code check above already returned on any cart carrying a
      // code we do not own. Revert 2026-07-21.
      const r = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code || '' }),
      });
      if (!r.ok) { // legacy fallback: cookie route
        if (code) await fetch('/discount/' + code);
        else clearDiscountCookie();
      }
    } catch (_) { /* non-blocking; checkout minimums still guard the codes */ }
  }

  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    const trigger = document.querySelector('.js-drawer-open-cart, [data-drawer-toggle="CartDrawer"], a[href$="/cart"]');
    if (trigger) { trigger.click(); return; }
    window.location.href = '/cart';
  }

  // --- Boot ---
  const resumed = restore();
  state.eligibility = readEligibility();
  shelfBox.checked = state.shelf;
  // Restore a More-options plan only if it still exists; never boot planless.
  if (state.planOv && state.planId && D.plans.some((p) => p.id === state.planId)) setWeeks(state.weeks, state.planId);
  else setWeeks(state.weeks || 4);
  if (!state.planId && D.plans.length) setWeeks(4);
  applyCadenceUI();
  let startStep = resumed ? state.step : 2; // direct-landing with a served ZIP skips the gate
  if (!canOrder()) startStep = 1;
  goTo(startStep, { boot: true });
}
